<footer class="row footer-espacamento">
  <div class="footer-column col-lg-5 col-12">
    <div class="primeira-secao-footer">
      <div style="text-align: center; margin-right: 1rem;">
        <img width="110px" src="images/brasao-mg.svg" alt="Brasão de Minas Gerais"/>
      </div>
      <div style="text-align: left; line-height: 1rem;">
        <h6 style="padding-bottom: 0.5rem;">Diário Oficial Eletrônico Minas Gerais</h6>
        <p class="show-in-bigger-screen-only" style="padding-bottom: 0.5rem;">Superintendência de Gestão do Diário Oficial</p>
        <p class="show-in-bigger-screen-only" style="padding-bottom: 0.5rem;">Secretaria de Estado de Governo de Minas Gerais</p>
      </div>
    </div>
  </div>
  <div class="footer-column col-lg-2 col-6">
    <h6>Principal</h6>
    <ul>
      @for(menu of menuPrincipal; track $index){
        @if(!menu.ocultarFooter) {
          <li tabindex="0" (click)="buttonAction(menu)" (keyup.enter)="buttonAction(menu)">{{menu.nome}}</li>
        }
      }
    </ul>
    <div class="selos-midia">
      <a href="https://www.ouvidoriageral.mg.gov.br/" target="_blank" rel="noopener noreferrer">
      <img src="images/selo-oge.svg" alt="SELO OGE: Ouvidoria geral - MG. Denuncie, disque 162."/>
      </a>
      <a href="https://sites.tcu.gov.br/verifique-adesao-pnpc/" target="_blank" rel="noopener noreferrer">
      <img src="images/selo-prevencao.svg" alt="SELO PREVENÇÃO: Programa Nacional de Prevenção à Corrupção"/>
      </a>
    </div>
  </div>
  <div class="footer-column col-lg-2 col-6">
    <h6>Links úteis</h6>
    <ul>
      @for(link of linksUteis;track $index){
        <li tabindex="0" (click)="buttonAction(link)" (keyup.enter)="buttonAction(link)">{{link.nome}}</li>
      }
    </ul>
  </div>
  <div class="footer-column footer-column-atendimento col-lg-3 col-12">
    <h6>Atendimento</h6>
    <div class="row">
      @for(telefone of telefonesTexto; track $index) {
        <a class="col-lg-12 col-6" href="https://wa.me/55{{telefone.replace('(','').replace(')','').replace('-','')}}" target="_blank" rel="noopener noreferrer">
        <img alt="Ícone de telefone" width="25px" style="margin-right: 5px;" src="icons/phone-line-white.svg"/><img width="20px" src="icons/mini-whatsapp.svg" alt="Ícone do whatsapp"/><span style="padding-left: 5px;">{{telefone}}</span>
        </a>
      }
    </div>
    <img width="25px" src="icons/mail-outline-white.svg" alt="ícone de um envelope"/><span style="padding-left: 5px;">{{emailTexto}}</span><br>
  </div>

  <div class="col-12 selos-midia-mobile">
      <a href="https://www.ouvidoriageral.mg.gov.br/" target="_blank" rel="noopener noreferrer">
      <img src="images/selo-oge.svg" alt="SELO OGE: Ouvidoria geral - MG. Denuncie, disque 162."/>
      </a>
      <a href="https://sites.tcu.gov.br/verifique-adesao-pnpc/" target="_blank" rel="noopener noreferrer">
      <img src="images/selo-prevencao.svg" alt="SELO PREVENÇÃO: Programa Nacional de Prevenção à Corrupção"/>
      </a>
  </div>
</footer>
<div class="social-footer" >
  <div>
    <p id="cidadeAdm">Cidade Administrativa Presidente Tancredo Neves</p>
    <p class="show-in-bigger-screen-only">Rodovia Papa João Paulo II, 4.000, Prédio Gerais, 1º Andar</p>
    <p class="show-in-bigger-screen-only">Bairro Serra Verde - BH / MG - CEP: 31630-901</p>
  </div>
  <div class="social-media-list">
    <span class="show-in-bigger-screen-only" style="font-weight: 600; margin-right: 0.5rem;">Siga nas redes</span>
    @for(sm of socialMedia; track $index){
    <a style="width: 40px;" target="_blank" rel='noopener noreferrer' [href]="sm.url"><img [src]="sm.src" [alt]="sm.alt" /></a>
    }
  </div>
</div>

@if(exibirVersaoRelease) {
<div class="version-footer">
  Versão: {{ versaoRelease }}
</div>
}
